<header class="header">
  <button
    (click)="uiService.toggleNavBarSmall()"
    type="button"
    class="un-btn button-navigation button-navigation--inheader"
    [ngClass]="{ 'button-navigation--close': uiService.navBarSmall }"
    title="Menu app"
  >
    <i class="glicon-burger-menu"></i>
  </button>

  <lms-search *lmsProfileGuard="'app.search'" [resourcesProviders]="resourcesProviders"></lms-search>

  <lms-account-menu [user]="user" (showCookies)="showCookiesConfig($event)"></lms-account-menu>
</header>
